import * as React from "react";

function SvgSimplifi(props, ref) {
  return (
    <svg
      viewBox="0 0 57.4 65"
      width="1em"
      height="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <g>
        <path
          fill="#21FC0D"
          d="M0,18c0,9.9,8.1,18,18,18V0C8.1,0,0,8,0,18z M24.9,14.5c0,8,6.5,14.5,14.6,14.5V0C31.4,0,24.9,6.5,24.9,14.5z M46.3,11.1c0,6.1,5,11.1,11.1,11.1V0C51.3,0,46.3,5,46.3,11.1z"
        />
        <path
          fill="#21FC0D"
          d="M39.4,29.1V65c9.9,0,18-8,18-18S49.4,29.1,39.4,29.1L39.4,29.1z M18,35.9V65c8.1,0,14.6-6.5,14.6-14.5C32.6,42.4,26.1,35.9,18,35.9L18,35.9L18,35.9z M0,42.7V65c6.2,0,11.2-5,11.2-11.1C11.2,47.7,6.2,42.7,0,42.7z"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgSimplifi);
